import './promo-code.global.css';

export const PromoCodeComponent = {
  template: `
    <span>Use promo code:</span>
    <ng-transclude></ng-transclude>
  `,
  transclude: true,
};
